var cibCampaignMonitor = ["32 32", "<path d='M31.781 5.693c-0.385-0.553-1.145-0.688-1.699-0.303l-29.864 20.916c0.219 0.313 0.584 0.521 0.995 0.521h29.573c0.672 0 1.213-0.547 1.213-1.219v-19.235c-0.005-0.235-0.079-0.468-0.219-0.681zM1.917 5.391c-0.553-0.385-1.313-0.251-1.699 0.303-0.14 0.208-0.213 0.443-0.219 0.681v19.265l14.219-11.651z'/>"];

export { cibCampaignMonitor };
